module.exports = __webpack_public_path__ + "static/media/footer_ico_lifestyle.7711d9f4.svg";